import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LABELS = { 1: "À améliorer", 2: "Moyen", 3: "Bien", 4: "Très bien", 5: "Excellent !" };

export default function TourneeAvis() {
  const [params] = useSearchParams();
  const q = { s: params.get("s") || "", e: params.get("e") || "", t: params.get("t") || "" };
  const [ctx, setCtx] = useState(null);
  const [err, setErr] = useState("");
  const [note, setNote] = useState(Math.min(5, Math.max(0, Number(params.get("n")) || 0)));
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(`${API}/tournee/public/avis`, { params: q }).then((r) => { setCtx(r.data); if (r.data.previous) { setComment(r.data.previous.comment || ""); } })
      .catch((e) => setErr(e.response?.data?.detail || "Lien invalide ou expiré."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => { if (ctx && note && !done && !ctx.previous) submit(note, ""); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx]);
  const submit = async (n, c) => {
    if (!n) return;
    setBusy(true);
    try { await axios.post(`${API}/tournee/public/avis`, { ...q, n, comment: c }); setDone(true); }
    catch (e) { setErr(e.response?.data?.detail || "Envoi impossible"); }
    finally { setBusy(false); }
  };
  const shown = hover || note;
  return (
    <div className="min-h-screen bg-[#f6f1e8] text-zinc-900 flex items-center justify-center px-5 py-10" style={{ fontFamily: "'Manrope', 'Segoe UI', sans-serif" }} data-testid="tournee-avis-page">
      <div className="w-full max-w-lg rounded-3xl bg-white border border-[#e7dcc5] shadow-sm p-7">
        <div className="text-[11px] tracking-[0.35em] text-[#b08b2e] font-bold">INSTITUT IMPACT ÉLITE MARTIAL · K'IZEN EN TOURNÉE</div>
        {err && <p className="mt-4 text-[#b3121f] font-semibold" data-testid="tournee-avis-error">{err}</p>}
        {!err && !ctx && <p className="mt-4 text-zinc-600">Chargement…</p>}
        {ctx && (
          <>
            <h1 className="text-2xl sm:text-3xl font-black mt-2 leading-tight">Comment avez-vous trouvé la formation ?</h1>
            <p className="text-sm text-zinc-600 mt-1">« {ctx.title} » · {ctx.city} · {ctx.date}</p>
            <div className="mt-6 flex gap-2" role="radiogroup" aria-label="Note sur 5" data-testid="tournee-avis-stars">
              {[1, 2, 3, 4, 5].map((n) => (
                <button key={n} type="button" onClick={() => { setNote(n); submit(n, comment); }} onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} aria-label={`${n} étoile${n > 1 ? "s" : ""}`} aria-checked={note === n} role="radio"
                  className={`text-4xl transition-transform hover:scale-110 ${n <= shown ? "text-[#d4af37]" : "text-zinc-300"}`} data-testid={`tournee-avis-star-${n}`}>★</button>
              ))}
            </div>
            <div className="mt-1 h-5 text-sm font-semibold text-zinc-700" data-testid="tournee-avis-label">{shown ? LABELS[shown] : ""}</div>
            <label className="block mt-5"><span className="text-xs text-zinc-500">Un commentaire pour Ralph ? (facultatif)</span>
              <textarea value={comment} onChange={(e) => setComment(e.target.value)} rows={3} maxLength={600} placeholder="Ce que vous avez aimé, ce qu'on peut améliorer…" className="mt-1 w-full px-3 py-2 rounded-xl border border-[#e7dcc5] bg-[#fbf8f2]" data-testid="tournee-avis-comment" /></label>
            <button type="button" disabled={!note || busy} onClick={() => submit(note, comment)} className="mt-3 px-6 py-3 rounded-full bg-[#b3121f] hover:bg-[#8f0e18] disabled:opacity-40 text-white font-bold" data-testid="tournee-avis-submit">{busy ? "Envoi…" : done ? "Mettre à jour mon avis" : "Envoyer mon avis"}</button>
            {done && <p className="mt-4 text-emerald-700 font-semibold" data-testid="tournee-avis-done">Merci ! Votre avis a bien été enregistré{note ? ` (${note}/5)` : ""}.</p>}
            <p className="mt-6 text-xs text-zinc-500">Envie de continuer ? <a href="/academie" className="text-[#b3121f] font-semibold">Académie K'izen en ligne</a> · <a href="/cours-essai" className="text-[#b3121f] font-semibold">Cours d'essai au dojo</a> · <a href="/tournee" className="text-[#b3121f] font-semibold">Prochaines dates</a></p>
          </>
        )}
      </div>
    </div>
  );
}
